import React, { useEffect, useState } from 'react';
import { ArrowRight, Award, TrendingUp } from 'lucide-react';
import { coachData } from '../data/mockData';
import '../styles/hero.css';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-rotate hero images every 5 seconds
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % coachData.heroImages.length);
        setIsTransitioning(false);
      }, 800); // Transition duration
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPrograms = () => {
    const element = document.querySelector('#programs');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      {/* Full-Screen Background Images */}
      <div className={`hero-background ${isTransitioning ? 'transitioning' : ''}`}>
        {coachData.heroImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`${coachData.name} - Professional Cricket Training ${index + 1}`}
            className={`hero-bg-image ${index === currentImageIndex ? 'active' : ''} ${
              isTransitioning && index === currentImageIndex ? 'fade-out' : ''
            } ${
              isTransitioning && index === (currentImageIndex + 1) % coachData.heroImages.length ? 'fade-in' : ''
            }`}
          />
        ))}
        <div className="hero-overlay"></div>
        <div className="motion-blur"></div>
        <div className="energy-particles"></div>
      </div>

      {/* Top Right Badges */}
      <div className="hero-badges-container">
        <div className="hero-badge-top">
          <Award size={14} />
          <span>Karnataka First-Class</span>
        </div>
        <div className="hero-badge-top top-scorer-badge">
          <Award size={14} />
          <div className="badge-content">
            <span className="badge-title">Top Scorer</span>
            <span className="badge-subtitle">2018-19 Ranji</span>
          </div>
        </div>
      </div>

      {/* Content Overlay */}
      <div className="hero-container">
        <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
          <h1 className="hero-title">
            Train with a<br />
            <span className="hero-highlight">First-Class Champion</span>
          </h1>
          
          <p className="hero-description">
            {coachData.tagline}
          </p>
          
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">728</div>
              <div className="stat-label">Runs in Debut Season</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">161</div>
              <div className="stat-label">Highest FC Score</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Years Experience</div>
            </div>
          </div>
          
          <div className="hero-cta">
            <button className="btn btn-primary btn-large" onClick={scrollToContact}>
              Book Your Trial Session
              <ArrowRight size={20} />
            </button>
            <button className="btn btn-white" onClick={scrollToPrograms}>
              <TrendingUp size={18} />
              View Programs
            </button>
          </div>
        </div>
      </div>
      
      {/* Image Navigation Dots */}
      <div className="hero-image-dots">
        {coachData.heroImages.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => {
              setIsTransitioning(true);
              setTimeout(() => {
                setCurrentImageIndex(index);
                setIsTransitioning(false);
              }, 400);
            }}
            aria-label={`View image ${index + 1}`}
          />
        ))}
      </div>
      
      {/* Decorative Elements */}
      <div className="hero-decoration hero-decoration-1"></div>
      <div className="hero-decoration hero-decoration-2"></div>
    </section>
  );
};

export default HeroSection;
